module.exports = __webpack_public_path__ + "static/media/login-background2.f9cc2d56.svg";